import Vue from 'vue'
import Order from '@services/order/orderAdapter'
import Dot from '@services/order/dotAdapter'
import Item from '@services/order/dotItemAdapter'
import Service from '@services/order/orderServiceAdapter'
import initialState from '../state'

export default {
  /**
   * Устанавливает аборт контроллер для запроса, либо убирает, если уже установлен
   * @param {requestNames} requestName
   */
  setAbortController(state, requestName) {
    if (!requestName) return

    if (state.requestAbortControllers[requestName]) {
      state.requestAbortControllers[requestName] = null
    } else {
      state.requestAbortControllers[requestName] = new AbortController()
    }
  },

  resetState(state) {
    Object.assign(state, JSON.parse(JSON.stringify(initialState)))
  },

  updateDeliveryMethod: (state, methodId) => {
    state.order.deliveryMethod = methodId
  },

  changeCity: (state, cityId) => {
    state.order.city = cityId
  },

  updateState: (state, data) => {
    if (data.length) {
      data.forEach(attr => {
        state[attr.key] = attr.value
      })
    } else {
      state[data.key] = data.value
    }
  },

  replaceState: (state, data) => {
    state[data.key] = {
      ...state[data.key],
      ...data.value,
    }
  },

  updateDot: (state, { dot, data }) => {
    const uniformitingData = dataItem => {
      let dotData = dataItem

      if (!dotData.length) {
        dotData = [dotData]
      }

      if (dotData.find(el => el.key === 'isSetAuto') === undefined) {
        dotData.push({
          key: 'isSetAuto',
          value: false,
        })
      }

      return dotData
    }

    uniformitingData(data).forEach(attr => {
      dot[attr.key] = attr.value
    })
  },

  updateItem: (state, { item, data }) => {
    if (data.length) {
      data.forEach(attr => {
        item[attr.key] = attr.value
      })
    } else {
      item[data.key] = data.value
    }
  },

  cleanDotAddress: (state, dot) => {
    dot.suburb = null
    dot.address = ''
    dot.street = ''
    dot.building = ''
    dot.metroId = ''
    dot.rightFormattedAddress = null
    dot.lat = null
    dot.lng = null
    dot.isMetro = false
    dot.isEnoughTime = true
  },

  updateOrder: (state, data) => {
    if (data.length) {
      data.forEach(attr => {
        state.order[attr.key] = attr.value
      })
    } else {
      state.order[data.key] = data.value
    }
  },

  setAdvanceCheque: (state, list) => {
    state.advanceCheque = list
  },

  startFormFetching: (state, status = true) => {
    state.isFormFetching = status
  },

  setWarningMessage: (state, data) => {
    state.warningMessageData = {
      title: data.title || null,
      body: data.body || null,
    }
  },

  updateFormLoading: (state, status = true) => {
    state.isFormLoading = status
  },

  setOrderCreatedMessage: (state, message) => {
    state.orderCreatedMessage = message
  },
  setOrderID(state, value) {
    state.orderId = value
  },

  setUrlToBindNewCard: (state, url) => {
    state.user.socket.paymentUrl = url
  },

  setAddressSuggestions: (state, { query, suggestions }) => {
    state.archiveAddressSuggestions.push({
      query,
      suggestions,
    })
  },

  updateShop: (state, data) => {
    if (data.length) {
      data.forEach(attr => {
        state.order.shop[attr.key] = attr.value
      })
    } else {
      state.order.shop[data.key] = data.value
    }
  },

  updatePromocode: (state, value) => {
    state.order.promocode.value = value
  },

  validPromocode: (state, value) => {
    state.order.promocode.validCode = value
  },

  updateApproveUserNumber: (state, number) => {
    state.approveUser.phoneNumber = number
  },

  updateApproveUserCode: (state, code) => {
    state.approveUser.code = code
  },

  updateApproveUserStatus: (state, status) => {
    state.approveUser.status = status
  },

  updateApproveUserMessage: (state, message) => {
    state.approveUser.message = message
  },

  updateApproveUserCodeFetchingStatus: (state, status = true) => {
    state.approveUser.isFetching = status
  },
  updateApproveUserTimeLeft: (state, value) => {
    state.approveUser.timeLeft = value
  },

  updateApproveUser: (state, user) => {
    state.user = user
  },

  validateApproveUserCode: (state, status = true) => {
    state.approveUser.isValided = status
  },

  updateAppToken: (state, token) => {
    state.appToken = token
  },

  setBaseState: (state, formData) => {
    Object.keys(formData).forEach(key => {
      state[key] = formData[key]
    })
  },
  setBaseProps: (state, value) => {
    state.base = value
  },
  setAdditionalProps: (state, value) => {
    state.additional = value
  },
  setOrderProps: (state, value) => {
    state.order = value
  },

  createOrder: state => {
    state.order = new Order({
      city: state.user.cityId || state.form.userCity || 1,
      // Для юр лиц методом оплаты по умолчанию "баланс"
      // для физ лиц "отправитель наличными"
      paymentMethod: null,
      promocode: {
        value: state.additional.promocode,
        validCode: null,
      },
      dots: [
        new Dot({
          timeTo: '23:59',
        }),
        new Dot({
          items: [
            new Item({
              index: state.nextItemIndex++,
            }),
          ],
        }),
      ],
    })
  },

  createDot(state, data) {
    data = { ...data }

    const createItems = function (items) {
      if (items) {
        return items.map(
          item =>
            new Item({
              ...item,
              index: state.nextItemIndex++,
            })
        )
      }

      return [new Item({ index: state.nextItemIndex++ })]
    }

    state.order.dots.push(
      new Dot({
        ...data,
        items: createItems(data.items),
      })
    )
  },

  removeDot({ order }, dot) {
    const index = order.dots.indexOf(dot)

    if (index > 0 && order.dots.length > 2) {
      order.dots.splice(index, 1)
    }
  },

  removeValidator(state, validator) {
    state.validatorsList = state.validatorsList.filter(validatorItem => validatorItem !== validator)
  },

  addDotItem(state, data) {
    const dot = data?.dot || {}
    const itemData = data?.item || {}

    if (!itemData.index) {
      itemData.index = state.nextItemIndex++
    }

    dot.items.push(new Item(itemData))
  },

  removeDotItem: (state, { dot, item }) => {
    const index = dot.items.indexOf(item)

    if (index > -1 && dot.items.length > 1) {
      dot.items.splice(index, 1)
    }
  },

  setPaymentMethod: (state, value) => {
    console.log(value)
    state.order.paymentMethod = value === null ? value : +value
    console.log(state.order.paymentMethod)
  },

  /**
   * @param {Object} state
   * @param {Boolean} value
   */
  setManualNarrowInterval: (state, value) => {
    state.manualNarrowInterval = value
  },

  /**
   * @param {Object} state
   * @param {Boolean} value
   */
  setManualOtherDay: (state, value) => {
    state.manualOtherDay = value
  },

  updatePaymentMethods: (state, value) => {
    state.form.deliveryPaymentMethods = value
  },

  updateBuyout: (state, value) => {
    state.base.isBuyout = value
  },

  updateformVersion: (state, value) => {
    state.additional.formVersion = value
  },

  createServices: (state, services) => {
    state.services = services.map(service => {
      const newService = {
        ...service,
      }

      const oldService = state.services.find(_service => _service.id === service.id)

      if (oldService) {
        newService.checked = oldService.isChecked
        newService.visible = oldService.isVisible
        newService.editable = oldService.isAvailable

        return new Service(newService)
      }

      const defaultService = state.defaultServices.find(_service => _service.id === service.id)

      if (defaultService) {
        newService.checked = defaultService.checked
        newService.visible = defaultService.visible
        newService.editable = defaultService.editable

        return new Service(newService)
      }

      return new Service(newService)
    })
  },

  createDefaultServices: state => {
    const { deliveryObject } = state.form

    state.defaultServices = state.form.clearServices.map(defaultService => {
      const service = {
        ...defaultService,
      }

      const isServiceAdded = deliveryObject && deliveryObject.payServices.includes(service.alias)

      if (isServiceAdded) {
        service.checked = true
      }

      return service
    })
  },

  toggleService: (state, serviceId) => {
    const service = state.services.find(service => service.id === serviceId)

    service.isChecked = !service.isChecked
  },
  turnOnService: (state, serviceId) => {
    const service = state.services.find(service => service.id === serviceId)

    service.isChecked = true
  },
  turnOffService: (state, serviceId) => {
    const service = state.services.find(service => service.id === serviceId)

    service.isChecked = false
  },

  turnOnServices: (state, data) => {
    data.item.services = [...data.services]
    data.services.forEach(updatedService => {
      const service = state.services.find(service => service.id === updatedService)

      service.isChecked = true
    })
  },

  turnOffServices: (state, item) => {
    const allItemsServices = state.order.dots
      .map(dot => dot.items.map(_item => (_item !== item ? _item.services : [])))
      .flat(2)

    item.services.forEach(itemService => {
      if (!allItemsServices.includes(itemService)) {
        const service = state.services.find(service => service.id === itemService)

        service.isChecked = false
      }
    })
    item.services = []
  },

  setСheckedServices: ({ checkedServices }, list) => {
    checkedServices = list
  },

  updateServices: (state, servicesToUpdate) => {
    state.services = state.services.map(service => {
      const serviceToUpdate = servicesToUpdate.find(
        _serviceToUpdate => _serviceToUpdate.id === service.id
      )

      // Если в списке к обнорвлению не найден итерируемый сервис - выключаем
      if (!serviceToUpdate)
        return {
          ...service,
          isChecked: false,
        }

      const { editable, checked, visible, ...updatedService } = serviceToUpdate

      if (typeof editable !== 'undefined') updatedService.isAvailable = editable
      if (typeof checked !== 'undefined') updatedService.isChecked = checked
      if (typeof visible !== 'undefined') updatedService.isVisible = visible

      return { ...service, ...updatedService }
    })
  },

  incrementStep: state => {
    state.currentActiveStep++
  },
  decrementStep: state => {
    state.currentActiveStep--
  },

  createAllDates: state => {
    const allDates = []
    const now = new Date()

    now.setHours(0, 0, 0, 0)

    const firstDay = now.getTime()
    const oneDayOffset = 24 * 60 * 60 * 1000 // Размер суток в мс
    const getDateObject = offset => new Date(firstDay + oneDayOffset * offset)

    for (let daysGone = 0; daysGone < 7; daysGone++) {
      const date = getDateObject(daysGone)

      const dayObj = {
        value: firstDay + oneDayOffset * daysGone,
        label: `${date.getDate()} ${state.monthStrings[date.getMonth()]}`,
      }

      allDates.push(dayObj)
    }

    state.form.allDates = allDates
  },

  /**
   * @param {{dotIdx: number, isNow: boolean}} val
   */
  setIsCurrentTime: (state, { dotIdx, isNow }) => {
    state.isCurrentTime = {
      ...state.isCurrentTime,
      [dotIdx]: isNow,
    }
  },

  createAllTimes: state => {
    const allTimes = []

    allTimes.push({
      value: `00:00`,
      label: 'Неважно',
    })

    for (let i = 0; i <= 23; i++) {
      const hour = String(i).padStart(2, '0')

      if (i > 0) {
        allTimes.push({
          value: `${hour}:00`,
          label: `${hour}:00`,
        })
      }

      allTimes.push({
        value: `${hour}:30`,
        label: `${hour}:30`,
      })
    }

    allTimes.push({
      value: `23:59`,
      label: 'Неважно',
    })
    allTimes.push({
      value: `23:59`,
      label: 'Выбрать',
    })
    state.form.allTimes = allTimes
  },

  updateFormWidth: state => {
    state.formWidth = document.documentElement.clientWidth
  },

  updateCurrentDate: (state, dateObject) => {
    state.currentDate = dateObject
  },

  deleteSuggestionLocal: (state, id) => {
    state.form.orderDraft = state.form.orderDraft.filter(el => el.tid != id)
  },

  toggleModals(state, data) {
    Object.keys(state.modals).forEach(name => {
      state.modals[name] = false
    })

    if (data) {
      state.modals[data] = true
    }
  },

  setSelectedDot(state, dot) {
    state.selectedDot = dot
  },

  setFavouriteCouriers({ user }, list) {
    user.favoriteCouriers = list
  },

  removeDeliveryDots({ order }) {
    order.dots.splice(1)
  },

  resetNextItemIndex(state) {
    state.nextItemIndex = 0
  },

  incrementNextItemIndex(state) {
    state.nextItemIndex += 1
  },

  setSelectedTemplate: (state, item) => {
    state.selectedTemplate = item
  },

  addNewPaymentCard: (state, card) => {
    state.user.cards.push(card)
  },

  addDraft: ({ form }, draft) => {
    form.orderDraft.push(draft)
  },

  addTemplate: ({ form }, template) => {
    form.template.push(template)
  },

  deleteTemplateLocal: (state, tid) => {
    const tmpIndex = state.form.orderTemplates.findIndex(tmp => tmp.tid == tid)

    if (tmpIndex != -1) {
      state.form.orderTemplates.splice(tmpIndex, 1)
    } else {
      const tmpIndex = state.form.orderDraft.findIndex(tmp => tmp.tid == tid)

      if (tmpIndex != -1) {
        state.form.orderDraft.splice(tmpIndex, 1)
      }
    }

    Vue.$toast.success('Шаблон успешно удален.', { position: 'top' })
  },

  /**
   * Устанавливаем для всех точек значение true, кроме той точки, ID которой был передан
   * @param {number | false} [dotId] номер точки для которой не хватает время
   */
  setNotEnoughTime: (state, dotId = false) => {
    state.order.dots.forEach((dot, index) => {
      dot.isEnoughTime = index !== dotId
    })
  },
  setPhoneCheckStatus(state, status) {
    state.phoneCheckStatus = status
  },

  setTokenGenerator(state, func) {
    state.tokenGenerator = func
  },
  setStateToOrderButton(state, bool) {
    state.isOrderButtonBlocked = bool
  },
  addValidator(state, validationObj) {
    state.validatorsList.push(validationObj)
  },
}
